import React from 'react';
import CategoryCard from './CategoryCard';
import { categories } from '../../data/categories';

const CategoryGrid = () => {
  return (
    <section className="py-6 sm:py-8 lg:py-10 px-4 sm:px-6 lg:px-8 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        {/* Mobile: Large, 2 small, Large, 2 small */}
        {/* Desktop: 3x2 flex with equal sizes */}
        
        {/* Row 1 */}
        <div className="flex flex-col sm:flex-row gap-4 mb-4 sm:mb-6">
          {/* Mobile: Large image (full width), Desktop: First column (wider) */}
          <div className="w-full h-[200px] sm:w-[550px] sm:h-[300px] mb-0 sm:mb-0">
            <CategoryCard category={categories[0]} />
          </div>
          {/* Mobile: 2nd and 3rd images side-by-side, Desktop: 2nd and 3rd columns (equal size) */}
          <div className="flex flex-row sm:flex-row gap-4 w-full sm:w-auto">
            <div className="w-1/2 h-[200px] sm:w-[350px] sm:h-[300px]">
              <CategoryCard category={categories[1]} />
            </div>
            <div className="w-1/2 h-[200px] sm:w-[350px] sm:h-[300px]">
              <CategoryCard category={categories[2]} />
            </div>
          </div>
        </div>
        
        {/* Row 2 */}
        <div className="flex flex-col sm:flex-row gap-4">
          {/* Mobile: Large image (full width), Desktop: First column (wider) */}
          <div className="w-full h-[200px] sm:w-[550px] sm:h-[300px] mb-0 sm:mb-0">
            <CategoryCard category={categories[3]} />
          </div>
          {/* Mobile: 2nd and 3rd images side-by-side, Desktop: 2nd and 3rd columns (equal size) */}
          <div className="flex flex-row sm:flex-row gap-4 w-full sm:w-auto">
            <div className="w-1/2 h-[200px] sm:w-[350px] sm:h-[300px]">
              <CategoryCard category={categories[4]} />
            </div>
            <div className="w-1/2 h-[200px] sm:w-[350px] sm:h-[300px]">
              <CategoryCard category={categories[5]} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CategoryGrid;

